import { Link } from "react-router-dom";
import bg from "../assets/img/troy-404-page.gif";

const NotFound = () => {
  return (
    <section className="bg-white py-10">
      <div className="w-ful">
        <div className="flex flex-col items-center justify-center space-y-4">
          <img src={bg} alt="" className="" />
          <h3 className="text-4xl text-[#0b1643]">Look like you're lost</h3>

          <p className="text-[#0b1643]">The page you are looking for not avaible!</p>

          <Link to="/" className=" bg-[#0b1643] p-4 rounded-md">
            Go to Home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default NotFound;
